(function () {
  document.querySelectorAll('.acc-ellaola-lp-01-announce__cd').forEach(function (el) {
    var h = el.querySelector('[data-cd="h"]');
    var m = el.querySelector('[data-cd="m"]');
    var s = el.querySelector('[data-cd="s"]');
    if (!h || !m || !s) return;

    var span =
      (parseInt(el.dataset.h, 10) || 0) * 3600 +
      (parseInt(el.dataset.m, 10) || 0) * 60 +
      (parseInt(el.dataset.s, 10) || 0);
    if (span <= 0) return;

    var key = 'acc-ellaola-lp-01-announce-cd-' + (el.id || '');
    var editing = !!(window.Shopify && window.Shopify.designMode);

    function read() {
      if (editing) return 0;
      try {
        var rec = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (!rec || rec.span !== span) return 0;
        return parseInt(rec.end, 10) || 0;
      } catch (e) {
        return 0;
      }
    }
    function write(end) {
      if (editing) return;
      try {
        sessionStorage.setItem(key, JSON.stringify({ end: end, span: span }));
      } catch (e) {}
    }
    function restart() {
      var end = Date.now() + span * 1000;
      write(end);
      return end;
    }

    var end = read();
    var now = Date.now();
    if (!end || end <= now || end - now > span * 1000) end = restart();

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function tick() {
      var t = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (t <= 0) {
        end = restart();
        t = span;
      }
      h.textContent = pad(Math.floor(t / 3600));
      m.textContent = pad(Math.floor((t % 3600) / 60));
      s.textContent = pad(t % 60);
    }
    tick();

    window.__accEllaolaLp01Countdowns = window.__accEllaolaLp01Countdowns || {};
    if (window.__accEllaolaLp01Countdowns[key]) clearInterval(window.__accEllaolaLp01Countdowns[key]);
    window.__accEllaolaLp01Countdowns[key] = setInterval(tick, 1000);
  });
})();
